import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  setSelectedStore: ["data"],
  setMerchant: ["merchant"],
  setStores: ["stores"],
  setStockTypes: ["stockTypes"],
});

export const StoreTypes = Types;
export default Creators;
